import React, { createContext, useContext, useState } from 'react';

/**
 * Manages header visual variant across landing pages.
 *
 * Variants:
 *  'default' — transparent/blurred (home page)
 *  'solid'   — fully opaque #0f0f0f background (contact page)
 */
const HeaderStyleContext = createContext({
  variant: 'default',
  setVariant: () => {},
});

export const HeaderStyleProvider = ({ children }) => {
  const [variant, setVariant] = useState('default');

  return (
    <HeaderStyleContext.Provider value={{ variant, setVariant }}>
      {children}
    </HeaderStyleContext.Provider>
  );
};

export const useHeaderStyle = () => useContext(HeaderStyleContext);
